module.exports = "https://cdn.littlereply.com/tt/resource/lh_toast_success.03607b0cff78450f527026b08292d261.png";